import { applyMiddleware, compose, createStore, combineReducers } from 'redux';
import promiseMiddleware from 'redux-promise-middleware';
import thunkMiddleware from 'redux-thunk';
import * as services from './services';
//import loggerMiddleware from "redux-logger";
import promiseRejectedMiddleware from 'store/promiseRejectedMiddleware';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middlewares = {
  // production: () =>
  //  applyMiddleware(
  //    thunkMiddleware.withExtraArgument(services),
  //    promiseRejectedMiddleware,
  //    promiseMiddleware(),
  //    ),
  // production: () => applyMiddleware(promiseMiddleware()),
  production: () =>
    composeEnhancers(
      applyMiddleware(
        thunkMiddleware.withExtraArgument(services),
        promiseRejectedMiddleware,
        promiseMiddleware()
        //loggerMiddleware
      )
    ),
  development: () =>
    composeEnhancers(
      applyMiddleware(
        thunkMiddleware.withExtraArgument(services),
        promiseRejectedMiddleware,
        promiseMiddleware()
        //loggerMiddleware
      )
    ),
  // test: () => applyMiddleware(promiseMiddleware())
  test: () => applyMiddleware(thunkMiddleware.withExtraArgument(services), promiseMiddleware()),
};

export default function configureStore(rootReducer, initialState = {}) {
  const store = createStore(
    rootReducer,
    initialState,
    middlewares[process.env.NODE_ENV]() || middlewares.development()
  );
  return store;
}



// WEBPACK FOOTER //
// src/store/configureStore.js